import React,{useState,useEffect} from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import CustomModal from './CustomModal';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import { useTranslation } from 'react-i18next';
import constants from '../../common/constants';
import {getCategories,getVideos} from '../../services/api';

import { FreeMode, Pagination } from 'swiper/modules';

const Categories = (props) => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';
  const [showModal, setShowModal] = useState(false);
  const [categoryId,setCategoryId] = useState('');
  const operator = localStorage.getItem('currentOperator');
  const [categories,setCategories] = useState();
  const user_id = props.user_id;
  const lang = i18n.language.toUpperCase();
  const [loading, setLoading] = useState(true);
  const m = localStorage.getItem('m');
  const [catCode,setCatcode] = useState();

  useEffect(() => {
    const fetchCategoriesAndVideos = async () => {
        try {
            const response = await getCategories(operator);
            let fetchedCategories = response.data.categories;
           
            let categoriesData = {};

            await Promise.all(
                fetchedCategories.map(async (category) => {
                    const videosResponse = await getVideos(category.code,operator);
                    const preferredLang = i18n.language;
                    const sortedVideos = videosResponse.data.videos.sort((a, b) => {
                      // Videos with preferred language come first
                      if (a.video_lang === preferredLang && b.video_lang !== preferredLang) return -1;
                      if (a.video_lang !== preferredLang && b.video_lang === preferredLang) return 1;
                      return 0;
                    });
                    // console.log(sortedVideos)
                    categoriesData[category.translations[lang]] = sortedVideos;
                })
            );

            // Convert categoriesData to an array of key-value pairs
            let categoriesArray = Object.entries(categoriesData);
    
            // Sort the array by the category name
            categoriesArray.sort(([keyA], [keyB]) => {
                    const nameA = keyA.toUpperCase();
                    const nameB = keyB.toUpperCase();
                    return nameA.localeCompare(nameB);
              });
    
            // Convert the sorted array back to an object
            categoriesData = Object.fromEntries(categoriesArray);
    
            // console.log(categoriesData);
            setCategories(categoriesData);
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
        finally {
          setLoading(false);
        }
    };

    fetchCategoriesAndVideos();
}, [operator, lang]);



  const handleShowModal = (catId,code) => {
    setCategoryId(catId);
    setCatcode(code)
    // setShowModal(true);
    // document.body.classList.add('no-scroll');
  };

  const handleCloseModal = () => {
    setShowModal(false);
    document.body.classList.remove('no-scroll'); // Enable scrolling
  };

    return (
      <div id='categories' className='categories-bg'>
        <div className='container'>
          <h2 className={`text-light text-center our-categories ${isArabic ? 'notokufi-bold' : 'avenir-heavy'}`}>{t('categories.title')}</h2>
               <CustomModal user_id={user_id} setUserId={props.setUserId} showModal={showModal} handleClose={handleCloseModal} categoryId={categoryId} categoryCode={catCode} />
               {categories ? (
                <>
                  {Object.entries(categories).map(([categoryName, videos]) => (videos.length > 0 && (
                        <>
                           <h5 className={`text-light text-capitalize ${isArabic ? 'notokufi-bold' : 'avenir-heavy'}`}>{categoryName}</h5>
                           <Swiper slidesPerView={3} spaceBetween={30} loop={true} freeMode={true} dir={`${isArabic ? 'rtl' : 'ltr'}`} className="mySwiper" key={categoryName}> 
                                {videos.map(video => (
                                  <>
                                  <SwiperSlide className='rtl-swiper-slide-mr' key={video.video_public_id}>
                                    <div>
                                        <div className="card" style={{ borderRadius: "20px",margin:"40px 0px" }} key={video.video_public_id}>
                                          <div style={{ position: 'relative', display: 'inline-block' }}>
                                              <img src={video.video_img} style={{ borderRadius: "20px 20px 0px 0px" }} className="card-img-top" />
                                          </div>
                                            <div className="card-body" style={{height:"150px",maxHeight:"150px"}}>
                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                    <h6 className={`card-title w-75 ${isArabic ? 'notokufi-bold' : 'avenir-heavy'}`} style={{ marginRight: "auto" }}>{video.translations[lang]?.title}</h6>
                    
                                                    <span className={`rtl-swiper-arrow-img pb-2 w-25 ${isArabic ? 'img-arrow-align' : 'text-end'}`}>
                                                      {props.hostname == 'ro' ? (
                                                        <>
                                                          {m ? (
                                                            <>
                                                              {video.video_url =='' ? (
                                                                  <a href={`/content/${video.video_public_id}?code=${video.category_name.toUpperCase()}`} key={video.video_public_id}><img src="../assets/images/lock.png" className='arrow-img-2' /></a>
                                                              ):(
                                                                  <a href={`/content/${video.video_public_id}?code=${video.category_name.toUpperCase()}`} key={video.video_public_id}><img src="../assets/images/arrow.png" className='arrow-img-2' /></a>
                                                              )}
                                                            </>
                                                          ):(
                                                            <>
                                                              <div key={video.video_public_id}><img src="../assets/images/lock.png" className='arrow-img-2' /></div>
                                                            </>
                                                          )}
                                                        </>

                                                      ):(
                                                        <>
                                                          {user_id ? (
                                                            <>
                                                              {video.video_url =='' ? (
                                                                  <a href={`/content/${video.video_public_id}?code=${video.category_name.toUpperCase()}`} key={video.video_public_id}><img src="../assets/images/lock.png" className='arrow-img-2' /></a>
                                                              ):(
                                                                  <a href={`/content/${video.video_public_id}?code=${video.category_name.toUpperCase()}`} key={video.video_public_id}><img src="../assets/images/arrow.png" className='arrow-img-2' /></a>
                                                              )}
                                                            </>
                                                          ) : (
                                                            <> 
                                                              {video.video_url =='' ?(
                                                                <button type="button" className='btn' onClick={() => handleShowModal(video.video_public_id,video.category_name.toUpperCase())} key={video.video_public_id}><img src="../assets/images/lock.png" className='lock-img' /></button>
                                                              ):(
                                                                <button type="button" className='btn' onClick={() => handleShowModal(video.video_public_id,video.category_name.toUpperCase())} key={video.video_public_id}><img src="../assets/images/arrow.png" className='arrow-img-1' /></button>
                                                              )}
                                              
                                                            </>
                                                          )} 
                                                        </>
                                                      )}
                                                    </span>
                                                </div>
                                                <p className={`card-text ${isArabic ? 'notokufi-regular' : 'avenir-book '}`}><small className="text-muted">{video.translations[lang]?.description.substring(0, 100)}...</small></p>
                                            </div>
                                        </div>
                                    </div>
                                 </SwiperSlide>
                                 </>
                                ))}
                           </Swiper>
                        </>
                )))}
                </>
               ):(
              <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "50vh" }}>
                <div className="spinner-border text-light" style={{ width: "3rem", height: "3rem" }} role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
              )}
        </div>
      </div>
    );
  };
  
  export default Categories;
